import { render, staticRenderFns } from "./PendingDocCreationHistoryFilterBox.vue?vue&type=template&id=313ff53b"
import script from "./PendingDocCreationHistoryFilterBox.vue?vue&type=script&lang=ts"
export * from "./PendingDocCreationHistoryFilterBox.vue?vue&type=script&lang=ts"
import style0 from "./PendingDocCreationHistoryFilterBox.vue?vue&type=style&index=0&id=313ff53b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports